const phrases = [
  'Frame the opportunity',
  'Design the system',
  'Build the product',
  'Learn in market',
];

const MotionMarquee = () => {
  const repeatedPhrases = [...phrases, ...phrases];

  return (
    <div className="motion-marquee border-y border-line/10 bg-highlight py-3 text-black">
      <div className="motion-marquee-track" aria-hidden="true">
        {repeatedPhrases.map((phrase, index) => (
          <span key={`${phrase}-${index}`} className="flex items-center gap-6">
            <span className="font-mono text-[0.7rem] font-bold uppercase tracking-[0.2em]">
              {phrase}
            </span>
            <span className="text-lg">✦</span>
          </span>
        ))}
      </div>
      <span className="sr-only">From opportunity framing through launch and learning.</span>
    </div>
  );
};

export default MotionMarquee;
